import React, { useEffect, useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Icon } from 'semantic-ui-react';
import { NavItem } from '.';

interface MenuDropdownItemProps {
  item: NavItem;
  menuIsOpen: boolean;
  renderNavigationLink: (
    routes: string[],
    label: string,
    messageId: string,
    className: string,
    onClick: () => void
  ) => React.ReactNode;
  setMenuIsOpen: (open: boolean) => void;
}

const DropdownItem: React.FC<MenuDropdownItemProps> = ({
  item,
  menuIsOpen,
  renderNavigationLink,
  setMenuIsOpen,
}) => {
  const intl = useIntl();
  const pathname = window.location.pathname.replace('C:/', '');
  const isActiveMenu = item.subMenu.some((subItem) =>
    subItem.routes.some((route: string) => `/${intl.locale}${route}` === pathname)
  );
  const [dropdownIsOpen, setDropdownIsOpen] = useState(isActiveMenu);

  useEffect(() => {
    if (!menuIsOpen && !isActiveMenu) {
      setTimeout(() => setDropdownIsOpen(false), 1000);
    }
  }, [menuIsOpen]);

  const toggleDropdown = () => {
    setDropdownIsOpen(!dropdownIsOpen);
  };

  return (
    <li>
      <button type="button" className="navbar-burger__link" onClick={toggleDropdown}>
        <FormattedMessage id={item.menuName} />
        <Icon name="caret down" className="navbar-burger__dropdown-icon" />
      </button>
      {dropdownIsOpen && (
        <ul className="navbar-burger__dropdown-menu">
          {item.subMenu.map((subItem) =>
            renderNavigationLink(
              subItem.routes,
              intl.formatMessage({ id: subItem.messageId }),
              subItem.messageId,
              'navbar-burger__link navbar-burger__link--sub',
              () => setMenuIsOpen(false)
            )
          )}
        </ul>
      )}
    </li>
  );
};

export default DropdownItem;
